import { getJson } from '~shared/utils/http';
import { buildSpectateStaticAssetUrl } from '~spa/Utils/Spectate';
import {
    getAliasesFilepath,
    getBrandDefaultLanguage,
} from '~spa/SpectateConfig';
import { getLanguageCode } from '~shared/utils/user';
import { getRewriteUrlLang } from '~shared/locales/utils/utils';

let aliases = {};

export const loadAliases = async() => {
    const aliasesFilepath = getAliasesFilepath();
    if (!aliasesFilepath) {
        return;
    }

    const response = await getJson(`${buildSpectateStaticAssetUrl(aliasesFilepath)}`);
    if (response.ok) {
        aliases = await response.json();
    }
};

const aliasContextId = (alias) => {
    const contextId = Object.keys(aliases).find(key => `${aliases[key]}/` === alias);

    return contextId;
};

export const getContextId = (url) => {
    const contextElement = url.split('/').filter(item => item).pop();
    const contextId = contextElement.match(/(s|coms|cos|e|st|t|to|toda|ipe|cot)-\d+(_\d+)?$/); // extract context id for url alias (e-123, toda-123_123 etc...)

    if (contextId === null) {
        return aliasContextId(url);
    }

    return contextId[0];
};

export const rewriteUrl = (url) => {
    if (url === '#') {
        return url;
    }

    const userLang = getLanguageCode();
    const defaultLang = getBrandDefaultLanguage();
    const langPrefix = (userLang !== defaultLang)
        ? getRewriteUrlLang(userLang)
        : '';

    if (!url || url === '/') {
        return `${langPrefix}/`;
    }

    const context = url.split('/').filter(item => item).pop();
    const matched = context.match(/(e|st|t|to|toda|ipe|cot)-\d+(_\d+)?$/); // extract context id for url alias (e-123, toda-123_123 etc...)
    const newUrl = aliases[matched ? matched[0] : context] || url;

    return `${langPrefix}/${newUrl.replace(/^\/|\/$/g, '')}/`;
};
